import React, { Component, Fragment } from "react";
import ReactSelect, { components } from "react-select";
import { doSMS } from "../../../functions/Twilio";
import { clearZero } from "../../../functions";
import Firebase from "../../../firebasehelper";
import ErrorModal from "./ErrorModal";
import {
  TerritoryOptions,
  CountryCode,
  CountryImages,
} from "../../../Utils/Constants";
import AvatarChoice from "../../../components/AvatarChoice";

const IconSendImg = require("../../../images/computer-icons-send.png");
const countryCodeOptions = [...new Set(Object.values(CountryCode))].map(
  (countrycode) => Object({ value: countrycode, label: countrycode })
);

const Option = (props) => {
  const { data } = props;
  console.log("options:", props);
  return (
    <components.Option {...props}>
      <img src={CountryImages[data.label]} width="25" height="25" />
      {data.label}
    </components.Option>
  );
};

let profile = {};
let q_a = [];

class MessageInput extends Component {
  state = {
    value: "",
    modalIsOpen: false,
    caption: "",
    content: "",
    checking_phone: false,
    fileupload: 0,
    countryCode: { value: "+44", label: "+44" },
  };
  constructor(props) {
    super(props);
    this.errorButton = React.createRef();
  }
  handleTouchStart = false;
  componentDidMount() {
    const { territory } = this.props;
    console.log("territory:", territory);
    if (territory === "USA") {
      this.setState({ countryCode: { value: "+1", label: "+1" } });
    }
  }
  getStaticMessage() {
    const { addMessage, message, logo } = this.props;

    if (Array.isArray(message.message)) {
      return (
        <div className="message-array">
          {message.message.map((message, i) => {
            return (
              <div
                className={`message message-static ${
                  logo === "ecosystem" ? " " : "notbolt"
                }`}
                onTouchStart={() => {
                  addMessage({
                    type: "user",
                    ...message,
                  });
                }}
                key={i}
              >
                {message.message}
              </div>
            );
          })}
        </div>
      );
    }
    return (
      <div
        className={`message message-static ${
          logo === "ecosystem" ? " " : "notbolt"
        }`}
        style={message.style}
        onClick={() => {
          addMessage(message);
        }}
      >
        {message.message}
      </div>
    );
  }

  addAvatar = (avatar) => {
    const { addMessage, message } = this.props;
    const { name, code } = avatar;
    profile[message.key] = code;
    addMessage({
      message: name,
      ticketType: avatar,
      ...message,
    });
  };

  handleCountryCode = (countryCode) => {
    this.setState({ countryCode });
  };

  bookCalendar = (date) => {
    const { addMessage, message } = this.props;
    addMessage({
      ...message,
      type: "user",
      message: new Date(date).toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
      }),
      key: message.key,
    });
  };

  getInputMessage() {
    const { value, checking_phone, countryCode } = this.state;
    const {
      message,
      logo,
      addMessage,
      territory = TerritoryOptions[0],
    } = this.props;

    return (
      <div className="message-input-outer">
        {message.key === "sms" && (
          <div
            className={`button ${logo === "ecosystem" ? "" : "notbolt"}`}
            onClick={(e) => {
              this.handleTouchStart = true;
              addMessage({
                type: "user",
                message: "I didn't receive a code.",
                inputType: "input",
                key: "no_received",
              });
            }}
          >
            I didn't receive a code
          </div>
        )}
        {message.key === "company_site" && (
          <div
            className={`button ${logo === "ecosystem" ? "" : "notbolt"}`}
            onClick={(e) => {
              this.handleTouchStart = true;
              profile[message.key] = "I don't have one.";

              addMessage({
                type: "user",
                message: "I don't have one.",
                inputType: "input",
                key: "company_site",
              });
            }}
          >
            I don't have one
          </div>
        )}
        <div className="message-input-container">
          {message.key.includes("phone") && (
            <ReactSelect
              className="country-select"
              value={countryCode}
              onChange={this.handleCountryCode}
              options={countryCodeOptions}
              menuPortalTarget={document.querySelector(
                "#phone_verification_modal"
              )}
              menuPlacement="top"
              styles={{
                control: (styles) => ({
                  ...styles,
                  backgroundColor: "white",
                  width: 80,
                }),
                option: (provided, state) => ({
                  ...provided,
                  display: "flex",
                  flexDirection: "row",
                  zIndex: 100,
                }),
              }}
              components={{ Option }}
            />
          )}
          <input
            type="text"
            value={value}
            placeholder={message.placeholder}
            className={message.key.includes("phone") ? "phone" : ""}
            onChange={this.onChange}
            onKeyPress={(e) => {
              if (e.charCode === 13) this.addMessage();
            }}
            onFocus={() => {
              this.setState(
                {
                  isFocused: true,
                },
                () => {}
              );
            }}
            onBlur={() => {
              this.setState({
                isFocused: false,
              });
            }}
            maxLength={message.maxLength}
          />

          {!checking_phone && (
            <div
              className={`send ${value ? "" : "disabled"} ${
                logo === "ecosystem" ? "" : "notbolt"
              }`}
              onClick={(e) => {
                if (value) {
                  if (this.handleTouchStart) {
                    setTimeout(() => {
                      this.handleTouchStart = false;
                    }, 1000);
                    e.preventDefault();
                    return;
                  }
                  this.handleTouchStart = true;
                  this.addMessage();
                } else {
                  this.errorButton.current.click();
                  this.setState({
                    modalIsOpen: true,
                    caption: "Warning",
                    content: "All fields are required!",
                  });
                }
              }}
            >
              <img src={IconSendImg} alt="send-icon" />
            </div>
          )}
          {checking_phone && (
            <p style={{ fontSize: 15, marginLeft: 0 }}>
              Checking phone number..
            </p>
          )}
        </div>
      </div>
    );
  }

  getAvatar() {
    const { message, avatars } = this.props;
    return (
      <AvatarChoice
        addMessage={this.addAvatar}
        message={message}
        ticketTypes={avatars}
        // tier_data={tier_data}
      />
    );
  }

  setSelectedOption = (index) => {
    const { addMessage, message } = this.props;
    const selectedOption = message.options[index]["value"];

    profile[message.key] = selectedOption;
    if (message.ticket)
      addMessage({
        type: "user",
        message: selectedOption,
        inputType: "toggleInput",
        key: message.key,
        ticket: message.ticket,
      });
    else
      addMessage({
        ...message,
        type: "user",
        message: selectedOption,
        inputType: "toggleInput",
        key: message.key,
      });
  };
  onChange = (e) => {
    this.setState({
      value: e.target.value,
    });
  };
  createPincode = () => {
    return Math.floor(100000 + Math.random() * 900000);
  };
  jsUcfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  addMessage = async () => {
    const {
      addMessage,
      message,
      is_member,
      logo,
      onCheckingNumberFailed,
      smsSender,
    } = this.props;
    const { value } = this.state;
    if (message.isCommunicationLayer) {
      q_a.push({ question: message.key, answer: value });
      addMessage({
        message: value,
        ...message,
      });
    }
    if (message.isConciergeRouting) {
      addMessage({
        message: value,
        ...message,
      });
    }
    if (message.key === "dob") {
      if (
        value &&
        !/^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.test(
          value
        )
      ) {
        this.errorButton.current.click();
        this.setState({
          modalIsOpen: true,
          caption: "Invalid format of date",
          content: "Please enter valid date essformat!",
        });
      } else if (value) {
        profile[message.key] = value;
        addMessage({
          type: "user",
          message: value,
          inputType: "input",
          isNext: message.isNext,
        });
      }
    } else if (message.key !== "email") {
      if (message.key === "phone") {
        let number = clearZero(value);
        let phone = this.state.countryCode.value + number;

        if (profile["is_member"] !== "Yes") {
          let pin = this.createPincode();
          pin = pin.toString();
          console.log("pin", pin);
          localStorage.setItem("phone", phone);
          localStorage.setItem("pin", pin);
          let response = doSMS(phone, pin, smsSender || logo);
          console.log("response", response);

          addMessage({
            type: "user",
            message: phone,
            profile: profile,
            key: "phone",
            inputType: "input",
            isNext: message.isNext,
          });
        } else {
          this.setState({ checking_phone: true });
          let res = await Firebase.getProfile(phone, logo);
          this.setState({ checking_phone: false });
          if (res && res.data()) {
            const { eco_id } = res.data();
            let pin = this.createPincode();
            pin = pin.toString();
            console.log("pin", pin);
            localStorage.setItem("phone", phone);
            localStorage.setItem("pin", pin);
            let response = doSMS(phone, pin, smsSender || logo);
            console.log("response", response);
            let ecoData = {};
            if (eco_id) {
              ecoData = await Firebase.getEcoUserbyId(eco_id);
            }
            addMessage({
              type: "user",
              message: phone,
              profile: { ...res.data(), ...ecoData, uid: res.id },
              key: "phone",
              inputType: "input",
              isNext: message.isNext,
            });
          } else {
            onCheckingNumberFailed();
            // this.setState({
            //   modalIsOpen: true,
            //   caption: "Error",
            //   content: `Your mobile number is not registered to an account. Please register now for free to access your community.`,
            // });
          }
        }
      } else if (message.key === "sms") {
        let phone = localStorage.getItem("phone");
        let pin = localStorage.getItem("pin");
        if (pin === value) {
          profile["phonenumber"] = phone;
          addMessage({
            type: "user",
            message: value,
            key: message.key,
            inputType: "input",
            is_member: is_member,
            profile: profile,
            phone: phone,
            isNext: message.isNext,
          });
        } else {
          addMessage({
            type: "user",
            message: value,
            key: "wrong_sms",
            inputType: "input",
            isNext: message.isNext,
          });
        }
      } else if (message.key === "bill-price") {
        profile[message.key] = value;
        addMessage({
          type: "user",
          message: value,
          profile: profile,
          key: message.key,
          inputType: "input",
          isNext: message.isNext,
        });
      } else {
        profile[message.key] = value;
        addMessage({
          type: "user",
          message: value,
          profile: profile,
          key: message.key,
          inputType: "input",
          isNext: message.isNext,
        });
      }
    }
  };
  componentWillLeave(callback) {
    const { message } = this.props;
    if (message.inputType !== "input") {
      this.setState({
        leaving: true,
      });
      setTimeout(() => {
        callback();
      }, 400);
    } else callback();
  }
  render() {
    const { leaving } = this.state;
    const { message, avatars } = this.props;

    return (
      <Fragment>
        {message && (
          <div
            className={`message-input-wrapper ${message.inputType} ${
              leaving ? "leaving" : ""
            }`}
            style={{ marginTop: 20 }}
          >
            {message.inputType === "static" ? this.getStaticMessage() : null}
            {message.inputType === "input" ? this.getInputMessage() : null}
            {message.inputType === "avatar-choice" ? this.getAvatar() : null}
          </div>
        )}
        <button
          ref={this.errorButton}
          data-toggle="modal"
          data-target="#error_show_modal"
          style={{ display: "none" }}
        ></button>
      </Fragment>
    );
  }
}

export default MessageInput;



// WEBPACK FOOTER //
// ./src/screens/Profile/components/MessageInput.js